// extracted by mini-css-extract-plugin
export default {"Form":"ContactStyles_Form__qqnMo","Icons":"ContactStyles_Icons__kOmk5","AltContact":"ContactStyles_AltContact__sGyVd"};